import {inject, Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {USER_PANEL_CONTEXT} from '../constants/contacts-api.constants';
import type {
  ContactGroup,
  ContactGroupListQuery,
  ContactGroupListResult,
  CreateContactGroupPayload,
} from '../types/contacts.types';
import {
  jsonStringBody,
  mapContactGroupModel,
  mapContactGroupPage,
  unwrapApiResult,
} from '../utils/contacts.mappers';
import type {ContactsGroupsApi} from './contacts-groups-api.port';
import {ContactsGroupsApiService} from './contacts-groups-api.service';

@Injectable()
export class ContactsGroupsApiHttpAdapter implements ContactsGroupsApi {
  private readonly http = inject(ContactsGroupsApiService);

  listGroups(query: ContactGroupListQuery = {}): Observable<ContactGroupListResult> {
    return this.http
      .listGroups({
        pageNumber: query.page ?? 1,
        pageSize: query.pageSize ?? 200,
        phrase: query.phrase,
        context: USER_PANEL_CONTEXT,
      })
      .pipe(map(response => mapContactGroupPage(unwrapApiResult(response))));
  }

  createGroup(payload: CreateContactGroupPayload): Observable<ContactGroup> {
    return this.http
      .createGroup({name: payload.name, context: USER_PANEL_CONTEXT})
      .pipe(map(response => mapContactGroupModel(unwrapApiResult(response))));
  }

  updateGroup(groupId: string, name: string): Observable<void> {
    return this.http
      .updateGroup(Number(groupId), jsonStringBody(name))
      .pipe(map(response => unwrapApiResult(response)), map(() => undefined));
  }

  deleteGroup(groupId: string): Observable<void> {
    return this.http
      .deleteGroup(Number(groupId))
      .pipe(map(response => unwrapApiResult(response)), map(() => undefined));
  }
}
